import { render, staticRenderFns } from "./digital-twin-canvas.component.vue?vue&type=template&id=7f928618&scoped=true"
import script from "./digital-twin-canvas.component.ts?vue&type=script&lang=ts&external"
export * from "./digital-twin-canvas.component.ts?vue&type=script&lang=ts&external"
import style0 from "./digital-twin-canvas.component.vue?vue&type=style&index=0&id=7f928618&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f928618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f928618')) {
      api.createRecord('7f928618', component.options)
    } else {
      api.reload('7f928618', component.options)
    }
    module.hot.accept("./digital-twin-canvas.component.vue?vue&type=template&id=7f928618&scoped=true", function () {
      api.rerender('7f928618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/digital-twin/digital-twin-canvas/digital-twin-canvas.component.vue"
export default component.exports